// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store'

import echarts from 'echarts'

Vue.prototype.$echarts = echarts;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

//三级联动
import VueAreaLinkAge from 'vue-area-linkage';
import 'vue-area-linkage/dist/index.css';


Vue.use(ElementUI);
Vue.use(VueAreaLinkAge);

Vue.use(Vuex);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js